import { Invoice, Product } from "./Billing";
import { Customer } from "./Customer";

export enum NoteTagType {
  CUSTOMER = "customer",
  PRODUCT = "product",
  INVOICE = "invoice",
}

export type Note = {
  id: string;

  text: string;
  notifyCustomer: boolean;

  invoiceId: string | null;
  invoice?: Invoice;

  productId: string | null;
  product?: Product;

  customerId: string | null;
  customer?: Customer;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};
